import { PageContext } from "../../types/pageContext";

// Page context
// TODO: Rethink this, some of the logic is being used elsewhere
export const initialPageContext: PageContext = {
	activeLink: "",
	hideNavbar: false,
	hideFooter: false,
	pathname: "",
};

export const initialState = {
	// TODO: Make deviceId persistent (for popup/redirects)
	currentUser: {
		deviceId: null,
		email: "",
		isLoggedIn: false,
	},
	menuRef: null,
	primaryNav: null,
	secondaryNav: null,
	primaryFooter: null,
	pdsFooter: null,
	runGuidedTour: false,
	pageContext: initialPageContext,
};

export const reducer = (state, action: any) => {
	switch (action.type) {
		// TODO: Remove getter and setter for user
		case "setCurrentUser":
			localStorage.setItem("currentUser", JSON.stringify(action.payload));
			return { ...state, currentUser: action.payload };
		case "removeCurrentUser":
			localStorage.removeItem("currentUser");
			const removed = { ...state.currentUser };
			removed.isLoggedIn = false;
			return { ...state, currentUser: removed };
		case "pageContext":
			const pathnameCheck = () => {
				const pathname = action.config.pathname
					? action.config.pathname
					: state.pageContext.pathname;
				const siteContext = pathname.split("/")[1];
				const paths = [
					"/employer/manage-products",
					"/member/accounts-overview",
				];
				if (paths.includes(pathname)) {
					return pathname;
				}
				return `/${siteContext}`;
			};

			const newPayload = {
				...state.pageContext,
				...action.config,
				pathname: pathnameCheck(),
			};
			return { ...state, pageContext: newPayload };
		case "menuRef":
			return {
				...state,
				menuRef: action.payload,
			};
		case "primaryNav":
			return {
				...state,
				primaryNav: action.payload,
			};
		case "secondaryNav":
			return {
				...state,
				secondaryNav: action.payload,
			};
		case "primaryFooter":
			return {
				...state,
				primaryFooter: action.payload,
			};
		case "pdsFooter":
			return {
				...state,
				pdsFooter: action.payload,
			};
		case "backBtnRef":
			return {
				...state,
				backBtnRef: action.payload,
			};
		case "guidedTour":
			return { ...state, runGuidedTour: action.payload };
		default:
			throw new Error("Action type must be defined");
	}
};
